import { render, staticRenderFns } from "./appModal.vue?vue&type=template&id=2fc4f6b9&"
import script from "./appModal.vue?vue&type=script&lang=ts&"
export * from "./appModal.vue?vue&type=script&lang=ts&"
import style0 from "./appModal.vue?vue&type=style&index=0&id=2fc4f6b9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports